import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';

const WhyChooseUsSection = () => {
  const { language } = useLanguage();
  const t = translations[language].why;

  return (
    <section className="section-services" data-aos="fade-up">
      <div className="choose-left">
        <h1 className="choose-ttitle">
          {t.title_part1}
          <span className="text-span-4">{t.title_highlight}</span>
        </h1>
        <p className="services-description">{t.description}</p>
      </div>
      <div className="services-rigth">
        <div className="w-layout-grid content-card">
          {t.cards.map((card, index) => (
            <div key={index} className="item-card">
              <img src={card.icon} width={28} alt="" className="image-card-service" />
              <h1 className="choose-title">{card.title}</h1>
              <p className="card-description-choose">
                <span className={card.spanClass}>{card.subtitle}</span><br /><br />
                {card.text.split('<br>').map((line, i) => (
                  <span key={i}>{line}<br /><br /></span>
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
